export enum UserAgreementStatusId {
  Accepted = "5af03874-8f4c-4ddb-8925-09f9ed815aeb",
  Pending = "44111c8b-3998-4c5a-8b64-649f9bdd1296",
  Cancelled = "d4ecb3f4-e244-4d45-9843-2ffaf7d0b63c",
  Rejected = "ed5ebb36-e881-4eab-92f4-031aaf320fb0",
}
